module.exports = __webpack_public_path__ + "img/icon7.68378071.png";